module.exports = __webpack_public_path__ + "static/media/f2.7588001d.jpg";